import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import ServiceUniverse from './components/ServiceUniverse';
import FeaturedReviews from './components/FeaturedReviews';
//import TransformationGallery from './components/TransformationGallery';
//import SocialProofSection from './components/SocialProofSection';
//import BookingCommandCenter from './components/BookingCommandCenter';
import Footer from '../../components/Footer';

const Homepage = () => {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';

    // Handle hash-based navigation (e.g., /#service-universe or /#service-universe-all)
    const hash = window.location.hash;
    if (hash) {
      console.log('🔍 Homepage detected hash:', hash);

      // Function to scroll to the target element
      const scrollToElement = () => {
        // Check if hash is for service-universe with category (e.g., #service-universe-all)
        if (hash.startsWith('#service-universe')) {
          const serviceUniverseSection = document.getElementById('service-universe');
          console.log('🎯 Looking for service-universe section:', serviceUniverseSection);
          if (serviceUniverseSection) {
            console.log('✅ Scrolling to Service Universe section');
            serviceUniverseSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return true;
          } else {
            console.log('❌ Service Universe section not found yet');
          }
        } else {
          // Handle other hash-based navigation
          const elementId = hash.substring(1);
          const element = document.getElementById(elementId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return true;
          }
        }
        return false;
      };

      // Try multiple times with increasing delays to ensure content is loaded
      const timeouts = [100, 300, 500, 1000];
      timeouts.forEach(delay => {
        setTimeout(() => {
          scrollToElement();
        }, delay);
      });
    }

    // Cleanup
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Sri Dhanwantari AyurVaidik Parishkar Kendra - Authentic Ayurvedic Healing</title>
        <meta
          name="description"
          content="At Sri Dhanwantari AyurVaidik Parishkar Kendra, we provide Trusted, Structured, Personalized, and Advanced Ayurvedic Care for Chronic & Autoimmune Conditions.
          We combine classical Ayurvedic principles with modern clinical insight to deliver precise, personalized treatment plans for psoriasis, spine/disc disorders, arthritis, autoimmune conditions, PCOD, obesity, thyroid, and metabolic diseases."
        />
        <meta
          name="keywords"
          content="ayurveda, psoriasis treatment, PCOD cure, joint pain relief, panchakarma, ayurvedic diet, natural healing, chronic disease treatment, ayurvedic clinic, AVN (Avascular Necrosis), MS (Multiple Schlerosis), Neck Pain, Back Pain,"
        />
        <meta name="author" content="Sri Dhanwantari AyurVaidik Parishkar Kendra" />
        <meta property="og:title" content="Sri Dhanwantari AyurVaidik Parishkar Kendra - Authentic Ayurvedic Healing" />
        <meta
          property="og:description"
          content="Holistic Ayurvedic treatment for chronic conditions. Experience the power of personalized therapy, diet, and exercise. Book your consultation today."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ayurparishkarkendra.com" />
        <meta property="og:image" content="https://ayurparishkarkendra.com/assets/images/APK_LogoVector1-1765235042576.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sri Dhanwantari AyurVaidik Parishkar Kendra - Ayurvedic Healing" />
        <meta
          name="twitter:description"
          content="Transform your health with authentic Ayurvedic treatment. Specialized care for psoriasis, PCOD, and chronic conditions."
        />
        <meta name="twitter:image" content="https://ayurparishkarkendra.com/assets/images/APK_LogoVector1-1765235042576.png" />
        <link rel="canonical" href="https://ayurparishkarkendra.com" />
      </Helmet>

      <div className="min-h-screen bg-background">
        {/* Header */}
        <Header />

        {/* Main Content */}
        <main className="pt-16 lg:pt-20">
          {/* Hero Section */}
          <HeroSection />

          {/* Service Universe */}
          <ServiceUniverse />

          {/* Featured Google Reviews */}
          <FeaturedReviews />

          {/* Transformation Gallery
          <TransformationGallery />*/}

          {/* Social Proof Section
          <SocialProofSection />*/}

          {/* Booking Command Center 
          <BookingCommandCenter />*/}
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default Homepage;